/**
 * Default configuration.
 */

export const appId = "452921604"; // eslint-disable-line
